import { Trans, useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import Progressbar from '../../../../../../../components/Progressbar';
import Typography from '../../../../../../../components/Typography';
import { i18nNS } from '../../../../../../../i18n';
import { Overlay } from '../styles';
import useAutoPollOverlay from './vm';

export interface AutoPollOverlayProps {
  canSeeResults: boolean;
}

const AutoPollOverlay = ({ canSeeResults }: AutoPollOverlayProps) => {
  const { t } = useTranslation([i18nNS.POLL]);

  const { canSeeOverlay, remainingTimeInSeconds, remainingTimeReadable, remainingPercentage } =
    useAutoPollOverlay();

  if (!canSeeOverlay) return null;
  if (remainingTimeInSeconds <= -1) return null;
  if (canSeeResults) return null;

  return (
    <Overlay>
      <Stack alignItems="center" gap={2}>
        <Stack justifyContent="center" alignItems="center" height={64} width={64}>
          <Progressbar
            shape="circular"
            variant="determinate"
            filled
            size={51.2}
            value={remainingPercentage}
            color="warning"
          />
        </Stack>
        <Typography variant="h4Bold" color="common.black" textAlign="center">
          <Trans
            t={t}
            ns={i18nNS.POLL}
            i18nKey="results_will_be_visible_once_the_poll_closes_in_N"
            tOptions={{ remainingTime: remainingTimeReadable }}
          >
            xxx Results will be visible once the poll closes in{' '}
            <Typography variant="inherit" component="span" color="warning">
              {remainingTimeReadable}
            </Typography>
          </Trans>
        </Typography>
      </Stack>
    </Overlay>
  );
};

export default AutoPollOverlay;
